import React from "react";
import { Turf, turfNaming } from "../../api/typesDc";
import { useTranslation } from "react-i18next";
import AutoComplete from "../AutoComplete";

const TurfAutocomplete = (props:any) => {
    const { selectedValues, manageSelect, isError, errorMessage, isReadOnly } = props;
    const [t] = useTranslation();
    const options = [
      { value: Turf.TURF_1, name: t(turfNaming[Turf.TURF_1]) },
      { value: Turf.TURF_2, name: t(turfNaming[Turf.TURF_2]) },
      { value: Turf.TURF_3, name: t(turfNaming[Turf.TURF_3]) },
      { value: Turf.TURF_4, name: t(turfNaming[Turf.TURF_4]) },
      { value: Turf.TURF_5, name: t(turfNaming[Turf.TURF_5]) },
      { value: Turf.TURF_6, name: t(turfNaming[Turf.TURF_6]) },
      { value: Turf.TURF_7, name: t(turfNaming[Turf.TURF_7]) },
      { value: Turf.TURF_8, name: t(turfNaming[Turf.TURF_8]) },
    ];

    const manageTurfSelect = (d:any) => {
      let tempTurf = [];
      const index = selectedValues.findIndex((item:any) => item == d.value);
      if(index !== -1) {
        tempTurf = selectedValues.filter((item:any) => item != d.value);
      } else {
        tempTurf = [...selectedValues, d.value];
      }
      manageSelect(tempTurf);
    }

    return (
        <>
            <AutoComplete 
            options={options}
            selectedValues={selectedValues}
            handleMenuClick={manageTurfSelect} 
            label={t('')}
            clickReset={() => {manageSelect([])}}
            isMultiple={true}
            variant={'standard'}
            isError={isError}
            errorMessage={errorMessage}
            isReadOnly={isReadOnly}
            />
        </>
    );
}

export default TurfAutocomplete;